import { Theme } from '@emotion/react';
import { Box, SxProps } from '@mui/material';
import React from 'react';

type Props = {
	textAlign?: 'center' | 'left' | 'right';
	weight: '700' | '500' | '400';
	size: '32px' | '28px' | '22px' | '20px' | '18px' | '16px' | '15px' | '14px';
	color: '#FFFFFF' | '#212B36' | '#39B54A';
	props?: SxProps<Theme> | undefined;
	opacity?: number;
} & React.HTMLAttributes<HTMLDivElement>;

const IMTitle = ({
	textAlign = 'left',
	color,
	size,
	weight,
	children,
	props,
	opacity = 1,
	...rest
}: Props) => {
	return (
		<Box
			sx={{
				fontFamily: '"Public Sans", sans-serif',
				fontWeight: weight,
				color,
				fontSize: size,
				lineHeight: '120%',
				textAlign,
				opacity,
				...(props || {}),
			}}
			{...rest}
		>
			{children}
		</Box>
	);
};

export default IMTitle;
